/**
 * Client/tenant display-name helpers.
 *
 * Session 68 pt4 — the team's policy is now: internally we refer to
 * a client by their **short name** everywhere except the client's
 * own detail screen (where their full legal name is the source of
 * truth). This module is the single place that codifies that rule
 * so every list / dropdown / breadcrumb / tooltip stays consistent.
 *
 * `clientDisplayName(client)`
 *   Returns the short name when present, otherwise falls back to
 *   the legal name. Accepts either a client object (`{ name,
 *   short_name }`) or a tenant blob (`{ name, short_name }`) —
 *   both shapes are interchangeable in the API surface.
 *
 * `clientLegalName(client)`
 *   Returns the legal name (the `name` field) for screens where
 *   the proper formal name is required: client overview header,
 *   contracts, invoices, audit logs.
 */
export function clientDisplayName(client) {
  if (!client) return "";
  const sn = (client.short_name || "").trim();
  const ln = (client.name || client.legal_name || "").trim();
  return sn || ln;
}

export function clientLegalName(client) {
  if (!client) return "";
  return (client.name || client.legal_name || "").trim();
}
